import { AfterContentChecked, AfterViewChecked, ChangeDetectionStrategy, ChangeDetectorRef, Component, ComponentFactory, ComponentFactoryResolver, EventEmitter, Input, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { NicaAnagraficaComponent } from '../nica-anagrafica/nica-anagrafica.component';
import { OverlaySideFormService } from '../shared/overlay-side-form/overlay-side-form.service';
import * as $ from 'jquery';
import { saveAs } from 'file-saver';
import { NicaFormComponent } from '../nica-form/nica-form.component';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { env } from 'process';
import { alert } from 'devextreme/ui/dialog';
import { AnteprimaPDfComponent } from '../shared/anteprima-pdf/anteprima-pdf.component';
import { map, take } from 'rxjs/operators';
import notify from 'devextreme/ui/notify';
import { F } from '@angular/cdk/keycodes';
import { DxiColumnComponent } from 'devextreme-angular/ui/nested';
import { AllLicenzeInstallate } from '../../services/dati.service';
import { AnagraficaService } from '../../services/anagrafica.service';
import { NicaMaster } from '../nica-master-component/nica-master.component';
import { ComponentService } from '../../services/component.service';
import { FormsTemplateService } from '../../services/forms-template.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NicaMenuService } from '../../services/nica-menu.service';
import { RentriService } from '../../services/rentri.service';
import { Utenteservice } from '../../services/utente.service';

export interface IAllegato {
  id: number;
  idTabella?: string;
  nomeTabella?: string;
  fileOrigine?: string;
  fileGuid?: string;
  dimensione?: number;
  note?: string;
  tipoFile?: string;
  folder?: string;
  ordine?: number;
  percorso?: string;
  idTag?: number;
  parolaChiave?: string;
  idTabellaPadre?:string;
  nomeTabellaPadre?:string;
};

export interface IAllegatoTag {
  id: number;
  descrizione?: string;
}

@Component({
  selector: 'app-allegati',
  templateUrl: './allegati.component.html',
  styleUrls: ['./allegati.component.css']
})
export class AllegatiComponent extends NicaMaster implements OnInit,AfterContentChecked  {

  @ViewChild('dataGridAllegati', { static: false }) dataGridAllegati: NicaAnagraficaComponent;
 // @ViewChild('allegatiForm', { static: false }) allegatiForm: NicaFormComponent;
  @ViewChild('anteprimaPDF', { static: false, read: ViewContainerRef }) anteprimaPDF: ViewContainerRef;


  @Input() itemData: any;
  @Input() queryString: any = '';
  @Input() dataJson: any;

  @Output() emittedData: EventEmitter<any> = new EventEmitter<any>(); //Emit all'esterno

  myFilterStr: string = '';
  idTabella: number; //id del dettaglio (anagrafica precedente)
  nomeTabella: string;  //nome tabella (anagrafica precedente)
  idTabellaPadre: number;
  nomeTabellaPadre:string;
  dati: any; //dati del dettaglio (anagrafica precedente)
  fileCaricato?: File;
  mimeType?: string;

  stoModificandoAllegato: boolean = false;
  mostraPopupAnteprima: boolean = false;
  imgFormID: string = 'dropzone-image';
  rowData: any = []
  allegatoDaModificare?: IAllegato;

  captionAllegati: string = "Inserimento Allegato";

  buttonCustom = [
    {
      location: "after",
      stylingMode: "text",
      widget: "dxButton",
      locateInMenu: "never",
      text: 'Salva',
      icon: "glyphicon mdi mdi-content-save-outline",
      event: 'salva',
      cssClass: 'escludiQuesto',
    },

    {
      location: "after",
      stylingMode: "text",
      widget: "dxButton",
      locateInMenu: "never",
      text: 'Annulla',
      icon: "glyphicon glyphicon icon-annulla-form",
      event: 'annulla',
      cssClass: 'escludiQuesto'
    },
  ];


  pulsanteFooterAllegati = {

    location: "after",
    widget: "dxButton",
    locateInMenu: "never",
    stylingMode: 'text',
    text: 'Chiudi',
    icon: "dx-icon dx-icon-close",
    event: 'chiudiPopup',
    class: '',
    onClick: () => {

      if (this.overlaySide)
        this.overlaySide.close();

    }
  };

  constructor(
    public userComponentService: ComponentService,
    public templateService: FormsTemplateService,
    public overlaySide: OverlaySideFormService,
    public _overlaySidePanelService: OverlaySideFormService,
    public formTemplateService: FormsTemplateService,
    public resolver: ComponentFactoryResolver,
    public activatedroute: ActivatedRoute,
    public router: Router,
    public menuService: NicaMenuService,
    public rentriService: RentriService,
    public anagaficaService: AnagraficaService,
    private userservice:Utenteservice,
    private cdr?: ChangeDetectorRef,
    private httpClient?: HttpClient,

  ) {
    super(
      userComponentService,
      templateService,
      overlaySide,
      _overlaySidePanelService,
      formTemplateService,
      resolver,
      activatedroute,
      router,
      menuService,
      rentriService,
      anagaficaService,


    );


  }


  ngAfterContentChecked(): void {
    this.cdr.detectChanges();
  }

  ngOnInit(): void {


    this.fileUploaderEventMouseMoving = this.fileUploaderEventMouseMoving.bind(this);
    this.fileUploaderOnDrop = this.fileUploaderOnDrop.bind(this);

    //console.warn(this.dataJson,this.itemData);
    /*  if (this.itemData) {
 
       this.idTabRif = this.itemData[0]['idTabRif'];    //es. 1
       if(this.itemData[0]['costantValue']){//es. Soggetti
         let IndexArrayNTab = this.itemData[0]['costantValue'].findIndex(dataFilter=> dataFilter.key == 'nomeTabella')
 
         if(IndexArrayNTab>-1){
           this.nomeTabRif = this.itemData[0]['costantValue'][IndexArrayNTab]['value']
         }
       } 
       this.dati = this.itemData[0]['dati'];
       this.myFilterStr = '?NomeTabella=' + this.nomeTabRif + '&IdTabella=' + this.idTabRif;
 
     } */

    if(this.dataJson['idTabella'] && this.dataJson['nomeTabella']){

      this.idTabella = this.dataJson['idTabella'];
      this.nomeTabella = this.dataJson['nomeTabella'];

    }

    if(this.dataJson['idTabellaPadre'] && this.dataJson['nomeTabellaPadre']){

      this.idTabellaPadre = this.dataJson['idTabellaPadre'];
      this.nomeTabellaPadre = this.dataJson['nomeTabellaPadre'];

    }


    if (typeof this.queryString != 'undefined') {
      //alert(this.queryString,'oo');
      this.myFilterStr = this.queryString
    }

    this.helpDoc = "Allegati.html"
    this.titleDynamic = 'Elenco allegati'
    console.log('Data JSON -------------------------------------------------------',this.dataJson)
    console.log('Data Query -------------------------------------------------------',this.queryString)
  }

  onAllegatoSelected(evt) {


  }

  async onAllEventAllegato(evt: any) {

    let t = this;

    //console.warn(evt);

    /*
    if(evt.name == 'onCellPrepared'){
      
      
      if(evt.data)
      if(!evt.data.tipoFile.toLowerCase().includes('image') && !evt.data.tipoFile.toLowerCase().includes('pdf')){
        
        //evt.component.columnOption('anteprimaButton','visible',false);

        //console.warn('EVENTO GRIGLIA bisogna rimuovere l icona',evt);



        //evt.cellElement.style='visibility:hidden;';
      }




    }
    */
    if (evt.name == "onInitNewRow") {


      evt.cancel = true;
      //console.log('sto aggiungendo un allegato');
      this.stoModificandoAllegato = false;

      let instanceData =
        {
         SubjectCall: 'allegatiForm',
         id: 'allegati', 
         ngClass:"soggetto-form",
         type:"simpleForm",
         disableEditForm:true,
         heightForm:"300",
         toolbarBottom:"true",
         dataJson:this.rowData,
         CustomButtonSetForm:this.buttonCustom,
         nCol:"2"  
         //(emittendButtonPush):"gestisciEventoPulsante($event)"
        };

      this.captionAllegati = 'Aggiunta Allegato';
      let guid = Math.random().toString().replace("0.", "")
      this.userComponentService.setNewPopUp(guid, 'NicaFormComponent', null, '855', null, instanceData, false, true, this.captionAllegati);
  
  
      this.userComponentService.outputComponent.subscribe(async(currentOutput) => {
  
        
        if(guid==currentOutput.guid){
          
          
          
          await this.onFormEvent(currentOutput,guid);


      
        }
      
      });

      
      this.cdr.detectChanges();

      let check = this.checkIfTagExist()
      if (check) {

        //this.formAllegatiVisibile = true;

      }
      /*
      let input = document.createElement('input');
      input.type = 'file';
      input.style.display = 'none';
      input.multiple = false;
      //input.accept = "image/png, image/jpeg, image/jpg";


      input.onchange = async () => {

        this.fileCaricato = input.files.item(0);

        

        let mimeType: string;
        //let size: number = this.fileCaricato.size;

        if (this.fileCaricato.name.split('.')[1].toLowerCase() == 'exe' || this.fileCaricato.name.split('.')[1].toLowerCase() == 'msi' || this.fileCaricato.name.split('.')[1].toLowerCase() == 'bat' || this.fileCaricato.name.toLowerCase().includes('.exe') || this.fileCaricato.name.toLowerCase().includes('.msi') || this.fileCaricato.name.toLowerCase().includes('.bat')) {

          //(document.getElementById(this.imgFormID) as HTMLImageElement).style.visibility = 'hidden';
          //(document.getElementById(this.imgFormID) as HTMLImageElement).src = undefined;
          //this.allegatiForm.formEdit.instance.updateData('fileOrigine', '');


          this.fileCaricato = undefined;
          this.mimeType = undefined;


          alert('Non è possibile allegare files di questo formato!', 'Attenzione');


          return;
        }


        if((this.fileCaricato.size / 1024 / 1024)>5){


          //(document.getElementById(this.imgFormID) as HTMLImageElement).style.visibility = 'hidden';
          //(document.getElementById(this.imgFormID) as HTMLImageElement).src = undefined;
          //this.allegatiForm.formEdit.instance.updateData('fileOrigine', '');

    

          this.fileCaricato = undefined;
          this.mimeType = undefined;


          alert('Dimensioni File superiori al limite di 5 MB', 'Attenzione');

          return;
        }


        let index = (allegatiTemp as any[]).findIndex((allegato)=>{return allegato.fileOrigine.toLowerCase() === this.fileCaricato.name.toLowerCase() });
        
        //Non si sa perchè ma l'api salva il file tutto in minuscolo a prescindere 

        if(index !== -1){

          
          this.fileCaricato = undefined;
          this.mimeType = undefined;


          alert('Già presente file con medesimo nome, si prega di cambiare nome del file e riprovare', 'Attenzione');

          return;

        }

        var reader = new FileReader();

        reader.onload = async function (event) {
          var dataURL = (event.target as any).result;
          t.mimeType = (dataURL as string).split(",")[0].split(":")[1].split(";")[0];
          console.debug(t.mimeType);

        let formData: FormData = new FormData();
        const note = undefined; //this.allegatiForm.formEdit.formData.note


        formData.append('file', t.fileCaricato);

        formData.set('nomeTabella', t.nomeTabRif);
        formData.set('idTabella', t.idTabRif.toString());

        if (t.fileCaricato) {
          formData.set('fileOrigine', t.fileCaricato.name);


          formData.set('tipoFile', t.mimeType);
          formData.set('dimensione', t.fileCaricato.size.toString());
        }


        formData.set('note', typeof note != 'undefined' ? note : ''); //Letto dal Nica Form


          
        await t.httpClient.post(environment.BASE_API_URL.concat('Allegato'), formData).toPromise();



        t.dataGridAllegati.refresh();

        };

        reader.readAsDataURL(this.fileCaricato);

        
    }

    input.click();
    */
    }


    if (evt.name == "onEditorPrepared") {

      evt.cancel = true;

      this.cdr.detectChanges();

      //console.log('sto aggiungendo un allegato');
      this.stoModificandoAllegato = true;

      let instanceData =
        {
          SubjectCall: 'allegatiForm',
         id: 'allegati', 
         ngClass:"soggetto-form",
         type:"simpleForm",
         disableEditForm:true,
         heightForm:"300",
         toolbarBottom:"true",
         dataJson:this.rowData,
         CustomButtonSetForm:this.buttonCustom,
         nCol:"2"  
         //(emittendButtonPush):"gestisciEventoPulsante($event)"
        };


        let allegatoDaModificare: IAllegato = await this.httpClient.get<IAllegato>(environment.BASE_API_URL.concat(`Allegato/${evt.data.id}`)).toPromise();

        if (!allegatoDaModificare) {
          this.allegatoDaModificare = undefined;
          this.stoModificandoAllegato = false;
          return;
        }

      this.captionAllegati = `Allegato: ${allegatoDaModificare.fileOrigine}`;  
      let guid = Math.random().toString().replace("0.", "");
      this.userComponentService.setNewPopUp(guid, 'NicaFormComponent', null, '855', {allegatoDaModificare}, instanceData, false, true, this.captionAllegati);
  
  
      this.userComponentService.outputComponent.subscribe(async(currentOutput) => {
  
        
        if(guid==currentOutput.guid){
          


          await this.onFormEvent(currentOutput,guid);


          

        }

      });
    }
  }
  async checkIfTagExist() {
    let desc = [];
    let queryString = ''
    let descrizioneTag

    if (typeof this.dataJson != 'undefined') {
      for (let x in this.dataJson) {
        desc.push(this.dataJson[x])
      }
      let descrizioneTag = desc.join('-')

      queryString = `?$filter=( descrizione eq '${descrizioneTag}') & $count=true`

      let dataPost = {
        descrizione: descrizioneTag
      }



      let checkIfExist = await this.anagaficaService.getElenco('AllegatoTag', '', queryString)
      if (checkIfExist['totalCount'] == 0) {
        let res = await this.anagaficaService.actionInsert('AllegatoTag', dataPost)

        
        this.rowData['idTag'] = res['id']

        if (this.rowData['idTag'] > 0) {
          
          return
        }
      }else{
        this.rowData['idTag'] = checkIfExist['items'][0]['id']
      }
      
    }
  }
  
  inserisciFile(throughInput?: boolean, fileDropped?: File, evt?:any) {

    let t = this;

    let caricaFile = function (input?: HTMLInputElement) {

      //console.warn(fileDropped)



      t.fileCaricato = (throughInput == true) ? input.files.item(0) : fileDropped;

      if ((t.fileCaricato.size / 1024 / 1024) > 25) {

        t.fileCaricato = undefined;
        t.mimeType = undefined;

        //alert('Dimensioni File superiori al limite di 25 MB', 'Attenzione');

        notify({
          message: 'Dimensioni File superiori al limite di 25 MB',
          height: 45,
          width: 250,
          position: 'center center'
        }, 'error', 4000);


        return;
      }



      //let mimeType: string;

      //let size: number = t.fileCaricato.size;

      if (t.fileCaricato.name.split('.')[1].toLowerCase() == 'exe' || t.fileCaricato.name.split('.')[1].toLowerCase() == 'msi' || t.fileCaricato.name.split('.')[1].toLowerCase() == 'bat' || t.fileCaricato.name.toLowerCase().includes('.exe') || t.fileCaricato.name.toLowerCase().includes('.msi') || t.fileCaricato.name.toLowerCase().includes('.bat')) {

        (document.getElementById(t.imgFormID) as HTMLImageElement).style.display = 'none';
        (document.getElementById(t.imgFormID) as HTMLImageElement).src = undefined;


        t.fileCaricato = undefined;
        t.mimeType = undefined;
        t.tempPopupEvent.updateData('fileOrigine', '');


        //alert('Non è possibile allegare files di questo formato!', 'Attenzione');

        notify({
          message: 'Non è possibile allegare files di questo formato!',
          height: 45,
          width: 250,
          position: 'center center'
        }, 'error', 4000);


        return;
      }

      var reader = new FileReader();

      reader.onload = function (event) {
        var dataURL = (event.target as any).result;
        t.mimeType = (dataURL as string).split(",")[0].split(":")[1].split(";")[0];
        //console.debug(t.mimeType);
      };

      reader.readAsDataURL(t.fileCaricato);


      setTimeout(() => {

        console.warn(t.tempPopupEvent);

        t.tempPopupEvent.updateData('fileOrigine', t.fileCaricato.name);

        if (t.mimeType.includes('image')) {

          /*
          let fileReader = new FileReader();
  
          fileReader.onload = ()=>{
            
            console.log(evt);
            t.allegatiForm.formEdit.instance.updateData('img',(fileReader.result as string));
  
          }
  
          fileReader.readAsDataURL(t.fileCaricato);
          */



          let url = URL.createObjectURL(t.fileCaricato);

          (document.getElementById(t.imgFormID) as HTMLImageElement).src = url;


        }
        else if (t.mimeType.includes('pdf')) {

          (document.getElementById(t.imgFormID) as HTMLImageElement).src = 'https://upload.wikimedia.org/wikipedia/commons/thumb/3/38/Icon_pdf_file.svg/1795px-Icon_pdf_file.svg.png'; //'https://upload.wikimedia.org/wikipedia/commons/thumb/8/87/PDF_file_icon.svg/1200px-PDF_file_icon.svg.png';


        }
        else if (t.mimeType.includes('sheet') || t.mimeType.includes('spread') || t.mimeType.includes('xls') || t.mimeType.includes('csv')) {

          (document.getElementById(t.imgFormID) as HTMLImageElement).src = 'https://upload.wikimedia.org/wikipedia/commons/thumb/3/31/Microsoft_Office_Excel_%282013%E2%80%932019%29.svg/2048px-Microsoft_Office_Excel_%282013%E2%80%932019%29.svg.png';

        }
        else if (t.mimeType.includes('word')) {

          (document.getElementById(t.imgFormID) as HTMLImageElement).src = 'https://upload.wikimedia.org/wikipedia/commons/thumb/8/8d/Microsoft_Word_2013-2019_logo.svg/254px-Microsoft_Word_2013-2019_logo.svg.png';

        }
        else if (t.mimeType.includes('presentationml') || t.mimeType.includes('powerpoint')) {

          (document.getElementById(t.imgFormID) as HTMLImageElement).src = 'https://upload.wikimedia.org/wikipedia/commons/1/16/Microsoft_PowerPoint_2013-2019_logo.svg';

        }
        else if (t.mimeType.includes('compressed')) {

          (document.getElementById(t.imgFormID) as HTMLImageElement).src = 'https://upload.wikimedia.org/wikipedia/commons/thumb/6/61/7zip_archive_icon.svg/2048px-7zip_archive_icon.svg.png';

        }
        else if (t.mimeType.includes('text/plain')) {

          (document.getElementById(t.imgFormID) as HTMLImageElement).src = 'https://upload.wikimedia.org/wikipedia/commons/thumb/e/e8/.txt_OneDrive_icon.svg/1200px-.txt_OneDrive_icon.svg.png';

        }
        else if (t.fileCaricato.name.split('.')[1].toLowerCase() == 'rar') {

          (document.getElementById(t.imgFormID) as HTMLImageElement).src = 'https://www.wikibit.it/wp-content/uploads/2017/06/rar.png';

        }
        else //Tutti gli altri files
          (document.getElementById(t.imgFormID) as HTMLImageElement).src = 'https://upload.wikimedia.org/wikipedia/commons/5/5c/Noun_Project_unknown_icon_762411_cc.svg';




        (document.getElementById(t.imgFormID) as HTMLImageElement).style.display = 'block';

        (document.getElementById("dropzone-text") as HTMLElement).style.display = "none";

      }, 500);
    }

    if (throughInput == true) {

      let input = document.createElement('input');
      input.type = 'file';
      input.style.display = 'none';
      input.multiple = false;

      input.onchange = () => {

        caricaFile(input);

      }

      input.click();
    }
    else
      caricaFile();




  }


  async gestisciEventoPulsante(evt: any) {

    let t = this;

    //console.log('gestisciEventoPulsante', evt)
    switch(evt.name){

      case 'annulla': {

        evt.masterComponent.formEdit.instance.resetValues();

        this.userComponentService.destroyCurrentOpenPopUp('NicaFormComponent');



        this.onChiudiPopupAllegato(evt);

      } break;
      case 'salva': {

        let formData: FormData = new FormData();
        const note = evt.masterComponent.formEdit.formData.note;
        const idTag = evt.masterComponent.formEdit.formData.idTag;
        const parolaChiave = evt.masterComponent.formEdit.formData.parolaChiave;

        formData.append('file', this.fileCaricato);

        formData.set('nomeTabella', this.nomeTabella);
        formData.set('idTabella', this.idTabella.toString());

        if(this.nomeTabellaPadre)
          formData.set('nomeTabellaPadre', this.nomeTabellaPadre);

        if(this.idTabellaPadre)
          formData.set('idTabellaPadre', this.idTabellaPadre.toString());

        if (this.fileCaricato) {
          formData.set('fileOrigine', this.fileCaricato.name);


          formData.set('tipoFile', this.mimeType);
          formData.set('dimensione', this.fileCaricato.size.toString());
        }

        
        formData.set('note', typeof note != 'undefined' ? note : ''); //Letti dal Nica Form
        
        formData.set('idTag', typeof idTag != 'undefined' ? idTag : '');
        
        formData.set('parolaChiave', typeof parolaChiave != 'undefined' ? parolaChiave : '');
        
        let validate = evt.masterComponent.formEdit.instance.validate();
        
        evt.masterComponent.formEdit.showValidationSummary = false;
        
        if (!validate.isValid)
          return;
        
          //PUT
        if (this.stoModificandoAllegato == true) {
          
          this.allegatoDaModificare.note = note;
          this.allegatoDaModificare.idTag = idTag;
          this.allegatoDaModificare.parolaChiave = parolaChiave;
          
          await this.httpClient.put<any>(environment.BASE_API_URL.concat(`Allegato/${this.allegatoDaModificare.id}`), JSON.stringify(this.allegatoDaModificare), { headers: { "content-type": "application/json" } }).toPromise();
          
          notify({
            message: 'Allegato modificato con successo',
            height: 45,
            width: 250,
            position: 'center center'
            
          }, 'success', 3000);
          
          
        } //POST
        else {
          
          //console.warn(this.itemData);
          
          if (!this.fileCaricato) {
            
            //alert("Si prega di caricare un file prima di procedere", "Attenzione");
            
            notify({
              message: 'Si prega di caricare un file prima di procedere',
              height: 45,
              width: 250,
              position: 'center center'
            }, 'error', 3000);
  
            
            
            return;
          }
          
          await this.httpClient.post(environment.BASE_API_URL.concat('Allegato'), formData).toPromise();
          
          notify({
            message: 'Allegato aggiunto con successo',
            height: 45,
            width: 250,
            position: 'center center'
          }, 'success', 3000);



        }

        /*
        else
          await this.httpClient.put(environment.BASE_API_URL.concat('Allegato'),formData).toPromise();
        */





        evt.masterComponent.formEdit.instance.resetValues();
        this.dataGridAllegati.refresh();
        this.userComponentService.destroyCurrentOpenPopUp('NicaFormComponent');

        this.onChiudiPopupAllegato(evt);


      } break;

    }

    if (evt.event && evt.event == 'caricaFile') {

      //input.accept = "image/png, image/jpeg, image/jpg";


      this.inserisciFile(true,undefined,evt);

    }
    else
      switch (evt) {

        
        /*
        case 'img':{
  
          console.log('evento immagine');
  
  
          setTimeout(
            ()=>{
  
  
            },500
          )
  
        }break;
        */
      }


  }

  tempPopupEvent : any = undefined;

  async onFormEvent(currentOutput:any,guid:string){

    if(currentOutput.eventName == 'buttonCustomClick' || currentOutput.event == 'caricaFile'){

      await this.gestisciEventoPulsante(currentOutput);

      return;
    }

    

    if(currentOutput.name == 'formContentReady'){

      this.onAperturaPopupAllegato(currentOutput,guid);

      if(this.stoModificandoAllegato == true)
      {
        setTimeout(async () => {

        let evt = currentOutput;



    (document.getElementById("dropzone-text") as HTMLElement).style.display = "none";

    

    let allegatoDaModificare : IAllegato = currentOutput.accessoringData.allegatoDaModificare;

  this.allegatoDaModificare = allegatoDaModificare;

  evt.masterComponent.updateData('fileOrigine', allegatoDaModificare.fileOrigine);
  evt.masterComponent.updateData('note', allegatoDaModificare.note);
  evt.masterComponent.updateData('idTag', allegatoDaModificare.idTag);
  evt.masterComponent.updateData('parolaChiave', allegatoDaModificare.parolaChiave);

  if (allegatoDaModificare.idTag) {

    let tag = await this.httpClient.get<IAllegatoTag>(environment.BASE_API_URL.concat(`allegatoTag/${allegatoDaModificare.idTag}`)).toPromise();

    if (tag)
    evt.masterComponent.updateData('descrizioneTag', tag.descrizione);

  }


  let editorUploadButton = evt.masterComponent.getEditor("uploadFile");

  if (editorUploadButton) {

    editorUploadButton.option("disabled", true);


  }


  

  this.stoModificandoAllegato = true;



  let estensioneFile = (allegatoDaModificare.fileOrigine as string).split('.')[(allegatoDaModificare.fileOrigine as string).split('.').length - 1].toLowerCase();



  if (!estensioneFile)
    return;

  if (estensioneFile == 'png' || estensioneFile == 'jpeg' || estensioneFile == 'jpg' || estensioneFile == 'svg') {

    /*
    let fileReader = new FileReader();

    fileReader.onload = ()=>{
      
      console.log(evt);
      this.allegatiForm.formEdit.instance.updateData('img',(fileReader.result as string));

    }

    fileReader.readAsDataURL(this.fileCaricato);
    */



    let url = environment.BASE_API_URL.concat(this.allegatoDaModificare.percorso);    //URL.createObjectURL(this.allegatoDaModificare.percorso);

    (document.getElementById(this.imgFormID) as HTMLImageElement).src = url;

  }
  else if (estensioneFile == 'pdf') {

    (document.getElementById(this.imgFormID) as HTMLImageElement).src = 'https://upload.wikimedia.org/wikipedia/commons/thumb/3/38/Icon_pdf_file.svg/1795px-Icon_pdf_file.svg.png'; //'https://upload.wikimedia.org/wikipedia/commons/thumb/8/87/PDF_file_icon.svg/1200px-PDF_file_icon.svg.png';

  }
  else if (estensioneFile == 'xls' || estensioneFile == 'xlsx' || estensioneFile == 'csv') {

    (document.getElementById(this.imgFormID) as HTMLImageElement).src = 'https://upload.wikimedia.org/wikipedia/commons/thumb/3/31/Microsoft_Office_Excel_%282013%E2%80%932019%29.svg/2048px-Microsoft_Office_Excel_%282013%E2%80%932019%29.svg.png';

  }
  else if (estensioneFile == 'docx' || estensioneFile == 'doc') {

    (document.getElementById(this.imgFormID) as HTMLImageElement).src = 'https://upload.wikimedia.org/wikipedia/commons/thumb/8/8d/Microsoft_Word_2013-2019_logo.svg/254px-Microsoft_Word_2013-2019_logo.svg.png';


  }
  else if (estensioneFile == 'ppt' || estensioneFile == 'pptx') {

    (document.getElementById(this.imgFormID) as HTMLImageElement).src = 'https://upload.wikimedia.org/wikipedia/commons/1/16/Microsoft_PowerPoint_2013-2019_logo.svg';

  }
  else if (estensioneFile == 'zip' || estensioneFile == '7zip') {

    (document.getElementById(this.imgFormID) as HTMLImageElement).src = 'https://upload.wikimedia.org/wikipedia/commons/thumb/6/61/7zip_archive_icon.svg/2048px-7zip_archive_icon.svg.png';


  }
  else if (estensioneFile == 'txt') {

    (document.getElementById(this.imgFormID) as HTMLImageElement).src = 'https://upload.wikimedia.org/wikipedia/commons/thumb/e/e8/.txt_OneDrive_icon.svg/1200px-.txt_OneDrive_icon.svg.png';


  }
  else if (estensioneFile == 'rar') {

    (document.getElementById(this.imgFormID) as HTMLImageElement).src = 'https://www.wikibit.it/wp-content/uploads/2017/06/rar.png';

  }
  else //Tutti gli altri files
    (document.getElementById(this.imgFormID) as HTMLImageElement).src = 'https://upload.wikimedia.org/wikipedia/commons/5/5c/Noun_Project_unknown_icon_762411_cc.svg';


  (document.getElementById(this.imgFormID) as HTMLImageElement).style.display = 'block';


          }, 500);
      }

    }
  }
  



  async onOptionalButtonClick(evt) {

    /*
    let downloadFile = (uri, name) => {
      let link = document.createElement("a");
      link.href = uri;
      link.download = name;
      //link.target = '_blank'; apre in una nuova tab
      link.click();
    };
    */

    let id: number = evt.row.data.id;
    let allegato = await this.httpClient.get<IAllegato>(environment.BASE_API_URL.concat(`Allegato/${id}`)).toPromise();

    switch (evt.name) {


      case 'anteprimaAllegato': {

        let link=environment.BASE_API_URL.concat("allegato/download?idTabella="+allegato.idTabella+"&nomeTabella="+allegato.nomeTabella+"&fileGuid="+allegato.fileGuid)
        const options = {
          method: 'GET', // Metodo della richiesta (es. GET, POST, PUT, DELETE)
          //mode: 'cors',
          headers: {
            'Content-Type': 'application/json', // Specifica il tipo di contenuto
            'Authorization': 'Bearer '+this.userservice.DammiToken(), // Esempio di header di autenticazione           
          }
        };
        
        if (!allegato.tipoFile.toLowerCase().includes('pdf') && !(allegato.fileOrigine as string).toLowerCase().endsWith('.pdf')) {
          //downloadFile(environment.BASE_API_URL.concat(allegato.percorso), allegato.fileOrigine); //sostituisce la tab attuale con il pdf

          //const FileSaver = require('file-saver');

          fetch(link, options).then(
            (res) => {
              res.blob().then(
                (blob: Blob) => {


                  saveAs(blob, allegato.fileOrigine);

                });
            }
          )


          //alterantiva saveAs(environment.BASE_API_URL.concat(allegato.percorso), allegato.fileOrigine);

          return;
        }

        let t = this;
        //idTabella nomeTabella guidNomeFile(fileGuid )
       
        fetch(link,options).then(
          (res) => {
            res.blob().then(
              (blob: Blob) => {
                
                
                let instanceData = {
                  isFile:true,
                  height:'800px',
                  $title:allegato.fileOrigine,
                  tipoFile: 'application/pdf',
                  caricamentoTerminato:true,
                  fileURL:URL.createObjectURL(blob),
                  fileData:blob,
                };
          
                const id='AnteprimaPDfComponent' ;
                let title = 'Anteprima di Stampa';
                this.userComponentService.setNewPopUp(id,'AnteprimaPDfComponent',[],'1200',null,instanceData,false,true,title,'top')
          
                this.userComponentService.outputComponent.subscribe(res=>{

                  if(res.name == 'close'){
                    this.userComponentService.destroyCurrentOpenPopUpByGuid(id)
                  }

                })
                
                /* setTimeout(() => {

                  t.mostraPopupAnteprima = true;

                  const factory = t.resolver.resolveComponentFactory(AnteprimaPDfComponent);

                  setTimeout(() => {

                    t.anteprimaPDF.clear();

                    let istanza = t.anteprimaPDF.createComponent(factory, 0);

                    //istanza.instance.isFile = true;

                    istanza.instance.pulsantiToolbarAnteprima = []; //Per il momento non è possibile mandare per email

                    istanza.instance.$title = allegato.fileOrigine;

                    istanza.instance.tipoFile = allegato.tipoFile.toLowerCase();

                    istanza.instance.fileData = blob;

                    //istanza.instance.fileData = this.
                    istanza.instance.nascondiTastoAnchor = false;

                    istanza.instance.apriAnteprimaDaFile();

                    //const url = environment.BASE_API_URL.concat(allegato.percorso);

                    //console.warn(url);


                  }, 500);
                }); */
              });
          })




        //stanza.instance.apriAnteprimaDaFile()
        /*
      

        
        try{
          
          let xhr = new XMLHttpRequest();

      xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
      xhr.setRequestHeader('Access-Control-Allow-Origin', '*');
      xhr.setRequestHeader('Content-type', 'application/pdf');

      let date = new Date();

       xhr.open('GET', environment.BASE_API_URL.concat(`${allegato.percorso}?timestamp=${date.getTime()}`),true);
       xhr.responseType='blob';

       xhr.onload = function () {

         if(this.status == 200){
           
           
           t.mostraPopupAnteprima = true;
           
           const factory = t.resolver.resolveComponentFactory(AnteprimaPDfComponent);

          setTimeout(() => {
            
            t.anteprimaPDF.clear();
            
            let istanza = t.anteprimaPDF.createComponent(factory, 0);
            
            istanza.instance.isFile = true;
            
            //console.log(evt);
            
            istanza.instance.$title = allegato.fileOrigine;
            
            istanza.instance.tipoFile = allegato.tipoFile.toLowerCase();
            
            //istanza.instance.fileData = this.
            
            
            
            let xhr = new XMLHttpRequest();
            xhr.open('GET', environment.BASE_API_URL.concat(allegato.percorso));
            
            xhr.onload = function () {
              const blob = new Blob([(xhr.response as Blob)], { type: 'application/pdf' }) //allegato.tipoFile
              
              console.warn(blob);

              istanza.instance.fileData = blob;
              
            }
 
           xhr.send();

            const url = environment.BASE_API_URL.concat(allegato.percorso);

            //console.warn(url);
            
            istanza.instance.fileURL = url;

            

              const blob = new Blob([this.response], { type: 'application/pdf', }) //allegato.tipoFile
                  
                  
                  istanza.instance.fileData = blob;

                
          
                  

                  
                  
            istanza.instance.emettiChiusura.subscribe
              ((x) => {
                if (x) {
                  t.anteprimaPDF.clear();
                  t.mostraPopupAnteprima = false;
                }
              });

              
              

            }, 500);
        }else
          console.error('Qualcosa è andato storto');
      }

      xhr.send();
      
    }catch(err){

      
      console.error('Qualcosa è andato storto');
      
      downloadFile(environment.BASE_API_URL.concat(allegato.percorso), allegato.fileOrigine); //sostituisce la tab attuale con il pdf
    } 
    
    */




      } break;






    }
  }




  chiudiPopupAnteprima(evt) {
    this.mostraPopupAnteprima = false;
    this.anteprimaPDF.clear();
  }

  //Fileuploader Devextreme
  onFileUploaderValueChanged(evt) {
    /*
    console.debug((evt.value[0] as File));

    let fileCaricato : File= (evt.value[0] as File);
    let mimeType : string;
    let size : number =  fileCaricato.size;

    var reader = new FileReader();

    reader.onload = function(event) {
      var dataURL = (event.target as any).result;
      mimeType = (dataURL as string).split(",")[0].split(":")[1].split(";")[0];
      console.debug(mimeType);
    };
    
    reader.readAsDataURL(fileCaricato);
    */
  }

  fileUploaderEventMouseMoving(ev: DragEvent) {

    ev.preventDefault();
    ev.stopPropagation();



    if ((ev.target as HTMLElement).id !== "dropzone") {

      //console.warn('sono fuori');


      ev.dataTransfer.effectAllowed = "none";
      ev.dataTransfer.dropEffect = "none";


      if (document.getElementById("dropzone")) {

        document.getElementById("dropzone").style.backgroundColor = "rgba(183, 183, 183, 0.1)";

        document.getElementById("dropzone").ondrop = () => {

          return;

        }

      }



      return;
    }

    //console.warn('sono dentro');

    document.getElementById("dropzone").style.backgroundColor = "var(--giallo)";


    document.getElementById("dropzone").ondrop = (evt) => {

      this.fileUploaderOnDrop(evt);

    }

    //console.warn(ev,this);

    //!(document.getElementById("dropzone").children.item(1) as HTMLImageElement).src

  }

  fileUploaderOnDrop(ev: any) {


    ev.preventDefault();
    ev.stopPropagation();

    console.warn(ev);


    //if(ev.target.id == 'dropzone'){

    document.getElementById("dropzone").style.backgroundColor = "rgba(183, 183, 183, 0.1)";
    this.inserisciFile(undefined, ev.dataTransfer.files[0]);

    //}


  }


  onAperturaPopupAllegato(evt : any,guid : string) {

    //console.warn(evt);

    let form : JQuery<HTMLElement> = $(`#${guid} app-nica-form`);   //document.getElementsByTagName('app-nica-form').item(0);

    //console.warn(form);

    if(form){

      form.addClass("formEditPopup"); //add class to overlay content
      form.addClass("formEditPopupContet"); //add class to content
      form.addClass("bg-grey"); //add class to content
      form.addClass("soggetto-form"); //add class to content
   


    }

    if(evt.masterComponent)
      this.tempPopupEvent = evt.masterComponent;
    else 
      this.tempPopupEvent = undefined;

  

    window.onresize = () => {
      //console.warn('sto ridimensionando', this.fileCaricato, this.mimeType);

      if ((document.getElementById('dropzone-image') as HTMLImageElement).style.display == 'none') {
        //console.warn(this.mimeType, this.fileCaricato)

        if (this.stoModificandoAllegato == true) {

          let estensioneFile = (this.allegatoDaModificare.fileOrigine as string).split('.')[(this.allegatoDaModificare.fileOrigine as string).split('.').length - 1].toLowerCase();


          if (!estensioneFile)
            return;

          /*let editorUploadButton = this.allegatiForm.formEdit.instance.getEditor("uploadFile");

          if (editorUploadButton) {

            editorUploadButton.option("disabled", true);


          }
          */


          if (estensioneFile == 'png' || estensioneFile == 'jpeg' || estensioneFile == 'jpg' || estensioneFile == 'svg') {

            /*
            let fileReader = new FileReader();
  
            fileReader.onload = ()=>{
              
              console.log(evt);
              this.allegatiForm.formEdit.instance.updateData('img',(fileReader.result as string));
  
            }
  
            fileReader.readAsDataURL(this.fileCaricato);
            */



            let url = environment.BASE_API_URL.concat(this.allegatoDaModificare.percorso);    //URL.createObjectURL(this.allegatoDaModificare.percorso);

            (document.getElementById(this.imgFormID) as HTMLImageElement).src = url;

          }
          else if (estensioneFile == 'pdf') {

            (document.getElementById(this.imgFormID) as HTMLImageElement).src = 'https://upload.wikimedia.org/wikipedia/commons/thumb/3/38/Icon_pdf_file.svg/1795px-Icon_pdf_file.svg.png'; //'https://upload.wikimedia.org/wikipedia/commons/thumb/8/87/PDF_file_icon.svg/1200px-PDF_file_icon.svg.png';

          }
          else if (estensioneFile == 'xls' || estensioneFile == 'xlsx' || estensioneFile == 'csv') {

            (document.getElementById(this.imgFormID) as HTMLImageElement).src = 'https://upload.wikimedia.org/wikipedia/commons/thumb/3/31/Microsoft_Office_Excel_%282013%E2%80%932019%29.svg/2048px-Microsoft_Office_Excel_%282013%E2%80%932019%29.svg.png';

          }
          else if (estensioneFile == 'docx' || estensioneFile == 'doc') {

            (document.getElementById(this.imgFormID) as HTMLImageElement).src = 'https://upload.wikimedia.org/wikipedia/commons/thumb/8/8d/Microsoft_Word_2013-2019_logo.svg/254px-Microsoft_Word_2013-2019_logo.svg.png';


          }
          else if (estensioneFile == 'ppt' || estensioneFile == 'pptx') {

            (document.getElementById(this.imgFormID) as HTMLImageElement).src = 'https://upload.wikimedia.org/wikipedia/commons/1/16/Microsoft_PowerPoint_2013-2019_logo.svg';

          }
          else if (estensioneFile == 'zip' || estensioneFile == '7zip') {

            (document.getElementById(this.imgFormID) as HTMLImageElement).src = 'https://upload.wikimedia.org/wikipedia/commons/thumb/6/61/7zip_archive_icon.svg/2048px-7zip_archive_icon.svg.png';


          }
          else if (estensioneFile == 'txt') {

            (document.getElementById(this.imgFormID) as HTMLImageElement).src = 'https://upload.wikimedia.org/wikipedia/commons/thumb/e/e8/.txt_OneDrive_icon.svg/1200px-.txt_OneDrive_icon.svg.png';


          }
          else if (estensioneFile == 'rar') {

            (document.getElementById(this.imgFormID) as HTMLImageElement).src = 'https://www.wikibit.it/wp-content/uploads/2017/06/rar.png';

          }
          else //Tutti gli altri files
            (document.getElementById(this.imgFormID) as HTMLImageElement).src = 'https://upload.wikimedia.org/wikipedia/commons/5/5c/Noun_Project_unknown_icon_762411_cc.svg';


          (document.getElementById(this.imgFormID) as HTMLImageElement).style.display = 'block';
        }
        else if (this.mimeType) {

          if (this.mimeType.includes('pdf')) {

            (document.getElementById('dropzone-image') as HTMLImageElement).src = 'https://upload.wikimedia.org/wikipedia/commons/thumb/3/38/Icon_pdf_file.svg/1795px-Icon_pdf_file.svg.png'; //'https://upload.wikimedia.org/wikipedia/commons/thumb/8/87/PDF_file_icon.svg/1200px-PDF_file_icon.svg.png';


          }
          else if (this.mimeType.includes('sheet') || this.mimeType.includes('spread') || this.mimeType.includes('xls') || this.mimeType.includes('csv')) {

            (document.getElementById('dropzone-image') as HTMLImageElement).src = 'https://upload.wikimedia.org/wikipedia/commons/thumb/3/31/Microsoft_Office_Excel_%282013%E2%80%932019%29.svg/2048px-Microsoft_Office_Excel_%282013%E2%80%932019%29.svg.png';

          }
          else if (this.mimeType.includes('word')) {

            (document.getElementById('dropzone-image') as HTMLImageElement).src = 'https://upload.wikimedia.org/wikipedia/commons/thumb/8/8d/Microsoft_Word_2013-2019_logo.svg/254px-Microsoft_Word_2013-2019_logo.svg.png';

          }
          else if (this.mimeType.includes('presentationml') || this.mimeType.includes('powerpoint')) {

            (document.getElementById('dropzone-image') as HTMLImageElement).src = 'https://upload.wikimedia.org/wikipedia/commons/1/16/Microsoft_PowerPoint_2013-2019_logo.svg';

          }
          else if (this.mimeType.includes('compressed')) {

            (document.getElementById('dropzone-image') as HTMLImageElement).src = 'https://upload.wikimedia.org/wikipedia/commons/thumb/6/61/7zip_archive_icon.svg/2048px-7zip_archive_icon.svg.png';

          }
          else if (this.mimeType.includes('text/plain')) {

            (document.getElementById('dropzone-image') as HTMLImageElement).src = 'https://upload.wikimedia.org/wikipedia/commons/thumb/e/e8/.txt_OneDrive_icon.svg/1200px-.txt_OneDrive_icon.svg.png';

          }
          else if (this.fileCaricato.name.split('.')[1].toLowerCase() == 'rar') {

            (document.getElementById('dropzone-image') as HTMLImageElement).src = 'https://www.wikibit.it/wp-content/uploads/2017/06/rar.png';

          }
          else //Tutti gli altri files
            (document.getElementById('dropzone-image') as HTMLImageElement).src = 'https://upload.wikimedia.org/wikipedia/commons/5/5c/Noun_Project_unknown_icon_762411_cc.svg';

          let url = URL.createObjectURL(this.fileCaricato);

          (document.getElementById('dropzone-image') as HTMLImageElement).src = url;


        }





        (document.getElementById('dropzone-image') as HTMLImageElement).style.display = 'block';

        (document.getElementById("dropzone-text") as HTMLElement).style.display = "none";

      }

    }




    setTimeout(() => {



      if ((document.getElementById('dropzone-image') as HTMLImageElement)) {



        (document.getElementById('dropzone-image') as HTMLImageElement).ondragstart = function () { return false; };


      }



      if (this.stoModificandoAllegato == true)
        return;

      document.body.addEventListener("dragenter", this.fileUploaderEventMouseMoving, false);
      document.body.addEventListener("dragover", this.fileUploaderEventMouseMoving, false);
      document.body.addEventListener("dragleave", this.fileUploaderEventMouseMoving, false);
      //document.getElementById('dropzone').addEventListener("drop",this.fileUploaderOnDrop,false);

    }, 500);
  }

  async onChiudiPopupAllegato(evt) {



    this.allegatoDaModificare = undefined;
    this.stoModificandoAllegato = false;
    this.tempPopupEvent = undefined;

    this.captionAllegati = "Inserimento Allegato";
    

    document.body.removeEventListener("dragenter", this.fileUploaderEventMouseMoving, false);
    document.body.removeEventListener("dragover", this.fileUploaderEventMouseMoving, false);
    document.body.removeEventListener("dragleave", this.fileUploaderEventMouseMoving, false);
    //document.getElementById('dropzone').removeEventListener("drop",this.fileUploaderOnDrop,false);
    window.onresize = () => {
      return;
    }


    /*

      Devextreme fa pena, tutto quello che c'è giù non funge

    setTimeout(
      async()=>{

        let colonnaTags = (this.dataGridAllegati.griglia.instance.columnOption("idTag") as DxiColumnComponent);

        let updatedTags : any[]=  await this.httpClient.get<IAllegatoTag[]>(environment.BASE_API_URL+'allegatoTag').toPromise();

        console.warn(updatedTags);

        colonnaTags.lookup.dataSource = updatedTags;

        //await this.dataGridAllegati.griglia.instance.refresh();

      },1000
    )
    */

  }


  
  emettiChiusuraCaption(evt){

    if(evt == 'closePopUpOverlay'){

      this.userComponentService.destroyCurrentOpenPopUp('AllegatiComponent')
    }

  }
}


